<template>
    
    <!-- Encabezado de la aplicación -->
    <div class="appHeader">
        <div class="left">
            <a href="#" class="headerButton goBack">
                <ion-icon name="chevron-back-outline"></ion-icon>
            </a>
        </div>
        <div class="pageTitle">
            Mi Portafolio
        </div>
        <div class="right">
            <a href="/crypto/exchange" class="headerButton">
                <ion-icon name="add"></ion-icon>
            </a>
        </div>
    </div>
    <!-- * Encabezado de la aplicación -->


    <!-- App Capsule -->
    <div id="appCapsule">
        <!-- {{networks}} -->

        <li class="placeholder-glow" v-if="networks.length==0">
            <!-- asset: {{ asset }} <br /> -->
            <div class="item">
                <div class="icon-box text-success">
                    <p class="placeholder col"></p>
                </div>
                <div class="in">
                    <div>
                        <strong class="placeholder col-6"></strong>
                        <div class="text-small text-secondary"></div>
                    </div>
                    <div class="text-end">
                        <strong class="placeholder col-6">
                        </strong>
                        <div class="text-small"></div>
                    </div>
                </div>
            </div>
        </li>
        <div class="section mt-2" v-for="(network, n_i) in networks" v-bind:key="'n_i'+n_i">
            <div class="section-title">{{network.name}} - {{network.type_wallet.scrypt.name}}</div>
            <div class="card">
                <!-- {{network}} -->
                <ul class="listview flush transparent no-line image-listview detailed-list mt-1 mb-1">
                    <!-- item -->
                    <li v-for="(asset, a_i) in network.assets" v-bind:key="'a_i'+a_i">
                        <div class="item">
                            <div class="icon-box text-success">
                                <ion-icon name="trending-up-outline"></ion-icon>
                            </div>
                            <div class="in">
                                <div>
                                    <strong>{{asset.currency.name}} ({{asset.currency.symbol}})</strong>
                                    <div class="text-small text-secondary">$ {{ asset.amount }}</div>
                                </div>
                                <div class="text-end">
                                    <strong>{{asset.balance}} {{asset.currency.symbol}}</strong>
                                    <div class="text-small">
                                        <span class="badge badge-success">
                                            <!-- <ion-icon name="arrow-up-outline"></ion-icon> -->
                                            {{asset.type}}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </li>
                    <!-- * item -->
                </ul>
            </div>
        </div>

    </div>
    <!-- * App Capsule -->
</template>

<script>
import { mapActions, mapState } from 'vuex';
export default {
  name: 'HomeView',
  data() {
    return {
    //   networks: [],
    //   currencies: [],
      assets: [],
      form: {
        network: 0,
        asset: 0,
      }
    };
  },
  matches: {
    'form.network'() {
      this.form.asset = 0;
    }
  },
  computed: {
    ...mapState(['userData', 'balance', 'last']),
    networks() {
      return this.$root.networks.balances;
    },
    currencies() {
      return this.$root.currencies;
    },
  },
  async mounted() {
    this.$root.loadBackButtom();
    this.$root.loadInputs();

    this.loadC()
  },
  methods: {
    ...mapActions(['logoutAPI', 'networksAPI', 'currenciesAPI']),
    loadC() {
      // eslint-disable-next-line
      document.querySelectorAll('.carousel-single').forEach(carousel => new Splide(carousel, {
          perPage: 3,
          rewind: true,
          type: "loop",
          gap: 16,
          padding: 16,
          arrows: false,
          pagination: false,
          breakpoints: {
              768: {
                  perPage: 1
              },
              991: {
                  perPage: 2
              }
          }
      }).mount());
    }
  },
}
</script>
